// extracted by mini-css-extract-plugin
export default {"SubmenuLink":"SubmenuItem_SubmenuLink__5bkjS","Active":"SubmenuItem_Active__qaNS6"};